import { jsx as _jsx } from "react/jsx-runtime";
import { InputMask as ReactInputMask } from "@react-input/mask";
import Input from "../Input/Input";
const InputMask = ({ mask, replacement, ...props }) => {
    return _jsx(ReactInputMask, { component: Input, mask: mask, replacement: replacement, ...props });
};
export default InputMask;
